import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./RootReducer";
import { initialStoreState } from "./initialStoreState";
import { accessLogMiddleware } from "./accessLogs/accessLogMiddleware";
import { globalMessagesMiddleware } from "./globalMessages/globalMessagesMiddleware";

export const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialStoreState,
  devTools: process.env.NODE_ENV !== "production",
  middleware(getDefaultMiddleware) {
    return getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(globalMessagesMiddleware).concat(accessLogMiddleware);
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
